import faker from '@faker-js/faker';
import {
  TAccountIdentifierType, TAccountType,
  TBankAccountType, TIdentificationType,
  TBeneficiary, TRoutingCodeType,
} from './types';

export const getBeneficiary = (): TBeneficiary => {
  const accountTypes = ['Company', 'Individual'] as TAccountType[];
  const bankAccountTypes = ['Checking', 'Saving', 'Maestra'] as TBankAccountType[];
  const identificationTypes = [
    'Company Organization Code',
    'Company Social Credit Code',
    'Passport',
    'Company Registration No.',
    'CUIT',
    'CUIL',
    'CPF',
    'CNPJ',
    'RUT',
    'CC',
    'NIT',
    'CE',
    'PASS',
    'DNI',
    'RUC',
    'CI',
  ] as TIdentificationType[];
  const routingCodeList = [
    'SWIFT',
    'IFSC',
    'SORT CODE',
    'ACH CODE',
    'BRANCH CODE',
    'BSB CODE',
    'BANK CODE',
  ] as TRoutingCodeType[];
  const accountIdentifierTypes = ['MOBILE', 'UEN', 'NRIC'] as TAccountIdentifierType[];

  return {
    merchant_id: faker.datatype.uuid(),
    name: faker.name.findName(),
    address: faker.address.streetAddress(true),
    city: faker.address.city(),
    state: faker.address.state(),
    postcode: faker.address.zipCodeByState('??'),
    country_code: faker.address.countryCode(),
    email: faker.internet.email(),
    account_type: (faker.helpers as any).arrayElement(accountTypes),
    contact_number: faker.phone.phoneNumberFormat(),
    account_number: faker.finance.iban(),
    bank_account_type: (faker.helpers as any).arrayElement(bankAccountTypes),
    bank_name: faker.finance.accountName(),
    bank_code: faker.finance.account(),
    relationship: 'Lunu Retailer',

    ...(faker.datatype.boolean() ? {contact_country_code: '+' + faker.mersenne.rand(999, 1)} : {}),
    ...(faker.datatype.boolean() ? {card_expiry_date: faker.date.recent().toISOString()} : {}),
    ...(faker.datatype.boolean() ? {
      account_identifier_type: (faker.helpers as any).arrayElement(accountIdentifierTypes),
      account_identifier_value: faker.finance.account(),
    } : {}),
    ...(faker.datatype.boolean() ? {card_token: faker.finance.creditCardNumber()} : {}),
    ...(faker.datatype.boolean() ? {name_local_language: faker.name.findName()} : {}),
    ...(faker.datatype.boolean() ? {} : {}),
    ...(faker.datatype.boolean() ? {identification_value: faker.finance.account(5)} : {}),
    ...(faker.datatype.boolean() ? {
      card_number: faker.finance.creditCardNumber(),
      encrypted_card_number: faker.finance.creditCardCVV(),
    } : {}),
    ...(faker.datatype.boolean() ? {dob: faker.date.recent().toISOString()} : {}),
    ...(faker.datatype.boolean() ? {wallet_id: faker.datatype.uuid()} : {}),
    ...(faker.datatype.boolean() ? {wallet_identification_type: (faker.helpers as any).arrayElement(identificationTypes)} : {}),
    ...(faker.datatype.boolean() ? {
      routing_code_type_1: (faker.helpers as any).arrayElement(routingCodeList),
      routing_code_value_1: faker.finance.routingNumber(),
      ...(faker.datatype.boolean() ? {
        routing_code_type_2: (faker.helpers as any).arrayElement(routingCodeList),
        routing_code_value_2: faker.finance.routingNumber(),
        ...(faker.datatype.boolean() ? {
          routing_code_type_3: (faker.helpers as any).arrayElement(routingCodeList),
          routing_code_value_3: faker.finance.routingNumber(),
        } : {}),
      } : {}),
    } : {}),
  } as TBeneficiary;
};
